var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit }) {
          return [
            !_vm.isSuccess
              ? _c(
                  "form",
                  {
                    staticClass: "login-form custom-form",
                    attrs: { id: "login-form", novalidate: "" },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.onSubmit)
                      }
                    }
                  },
                  [
                    _c("ValidationProvider", {
                      attrs: { mode: "lazy", rules: "required|email" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c(
                                  "fieldset",
                                  {
                                    staticClass:
                                      "login-form__field input__wrap",
                                    class: { "error-focus": errors.length > 0 }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.email,
                                          expression: "email"
                                        }
                                      ],
                                      ref: "emailInput",
                                      staticClass:
                                        "login-form__field__input required",
                                      class: {
                                        error: errors.length > 0,
                                        valid:
                                          _vm.email.length > 0 &&
                                          errors.length == 0
                                      },
                                      attrs: {
                                        id: "email",
                                        type: "email",
                                        autofocus: "",
                                        name: "email",
                                        disabled: _vm.isPending,
                                        required: ""
                                      },
                                      domProps: { value: _vm.email },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.email = $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("label", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "INPUT_EMAIL",
                                          expression: "'INPUT_EMAIL'"
                                        }
                                      ],
                                      staticClass: "login-form__field__label",
                                      attrs: { for: "email" }
                                    }),
                                    _vm._v(" "),
                                    errors.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "error-tooltip__wrap"
                                          },
                                          [
                                            _c("h4", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value: "INPUT_EMAIL_ERROR",
                                                  expression:
                                                    "'INPUT_EMAIL_ERROR'"
                                                }
                                              ],
                                              staticClass:
                                                "menu-link text-uppercase error-tooltip__content"
                                            }),
                                            _vm._v(" "),
                                            _c("p", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value:
                                                    "INPUT_EMAIL_ERROR_DESCRIPTION",
                                                  expression:
                                                    "'INPUT_EMAIL_ERROR_DESCRIPTION'"
                                                }
                                              ],
                                              staticClass: "description"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "fieldset",
                      {
                        staticClass:
                          "login-form__field login-form__field--button"
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "SubmitButton",
                                { attrs: { pending: _vm.isPending } },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("PASS_RECOVERY_BUTTON")) +
                                      "\n          "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12" }, [
                            _c("a", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "BACK_LOGIN_LINK",
                                  expression: "'BACK_LOGIN_LINK'"
                                }
                              ],
                              staticClass:
                                "button button--transparent-grad pulse m-t-10",
                              attrs: { href: "#" },
                              on: { click: _vm.goToLogin }
                            })
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isSuccess
              ? _c("div", { staticClass: "success-message text-center" }, [
                  _c("h1", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "PASS_RECOVERY_SUCCESS_TITLE",
                        expression: "'PASS_RECOVERY_SUCCESS_TITLE'"
                      }
                    ],
                    staticClass: "title md-title"
                  }),
                  _vm._v(" "),
                  _c("p", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "PASS_RECOVERY_SUCCESS_FIRST_LINE",
                        expression: "'PASS_RECOVERY_SUCCESS_FIRST_LINE'"
                      }
                    ],
                    staticClass: "subtitle"
                  }),
                  _vm._v(" "),
                  _c("p", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "PASS_RECOVERY_SUCCESS_SECOND_LINE",
                        expression: "'PASS_RECOVERY_SUCCESS_SECOND_LINE'"
                      }
                    ],
                    staticClass: "subtitle"
                  }),
                  _vm._v(" "),
                  _c("a", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "BACK_LOGIN_LINK",
                        expression: "'BACK_LOGIN_LINK'"
                      }
                    ],
                    staticClass: "button button--transparent-grad pulse m-t-40",
                    attrs: { href: "#" },
                    on: { click: _vm.goToLogin }
                  })
                ])
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }